import type { ImageLoader, ImageLoaderProps } from 'next/image';

import { MediaTypes } from '~constants/media';

const cfPublicLoader = ({ src, width, quality = 100 }: ImageLoaderProps) => {
	return `${src}/width=${width},quality=${quality},format=auto`;
};

const cfPublicVideoPreviewLoader = ({
	src,
	width,
	quality = 100,
}: ImageLoaderProps) => {
	// CF has width limit for some reason for this type of images
	const url = new URL(src);
	url.searchParams.append('width', String(width > 2000 ? 2000 : width));
	url.searchParams.append('quality', String(quality));
	return url.toString();
};
const cfLoader: ImageLoader = ({ src }) => {
	return src;
};

const _errorFn = () => {
	throw new Error('Attempt to process video via image component');
};
export const loaders: Record<MediaTypes, ImageLoader | undefined> = {
	cfpublic: cfPublicLoader,
	cf: cfLoader,
	[MediaTypes.videoCf]: cfPublicVideoPreviewLoader,
	[MediaTypes.videoPreviewCf]: cfPublicVideoPreviewLoader,
	[MediaTypes.videoDefaultPrivate]: _errorFn,
	[MediaTypes.videoDefault]: _errorFn,
	[MediaTypes.mp4]: undefined,
	[MediaTypes.defaultPrivate]: undefined, //use default as we're not planing to process it in case of anything
	default: undefined, // use undefined to apply default loader that optimizes images
} as const satisfies Record<MediaTypes, ImageLoader | undefined>;
